import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/home';
import Login from './ais/auth/login';
import CreateAccount from './ais/auth/create-account';
import ForgotPassword from './ais/auth/forgot-password';
import Dashboard from './ais/dashboard';
import UniversitiesList from './ais/pages/universties-list';
import AdminDashboard from './admin/AdminDashboard';
import AdminLogin from './admin/AdminLogin';
import ResetPassword from './ais/auth/reset-password';
import AccountLessApply from './pages/accountless-apply';
import UniversitiesPage from './pages/universities';
import Contact from './pages/contact';
import News from './pages/news';
// import HunanUniversity from './pages/universities/hunan-university';
// import NanchangUniversity from './pages/universities/nanchang-university';


function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path='' element={<Home />} />
      <Route path='aia/universities' element={<UniversitiesList />} />
      <Route path='login' element={<Login />} />
      <Route path='create-account' element={<CreateAccount />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password' element={<ResetPassword />} />
      <Route path='aas/universities-list' element={<UniversitiesList />} />
      <Route path='AGFA/apply' element={<AccountLessApply />} />
      <Route path='contact' element={<Contact />} />
      <Route path='news' element={<News />} />

      {/* protected routes */}
      <Route path='apply' element={<Dashboard />} />
      <Route path='aas/apply' element={<Dashboard />} />
      {/* <Route path='/aas/hunan-university' element={<HunanUniversity />} />
      <Route path='/aas/nanchang-university' element={<NanchangUniversity />} /> */}
      
      {/* admin routes */}
      <Route path='/admin-login' element={<AdminLogin />} />
      <Route path='/admin' element={<AdminDashboard />} />

    </Routes>
    </BrowserRouter>
  );
}

export default App;
